import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import { _ } from '/@/locale';

import Title from '/@/v3/components/title';

import styles from './styles.module.css';

@autobind
export default class WeedRow extends Component {
    static propTypes = {
        weed: PropTypes.object.isRequired,
        showImage: PropTypes.bool,
        loadImage: PropTypes.bool,
        handleClickWeed: PropTypes.func,
    };

    render() {
        const { weed, showImage, handleClickWeed } = this.props;
        if (!weed) return null;

        return (
            <div className={classNames(styles.root, styles.card)} onClick={handleClickWeed}>
                {showImage && (
                    <div className={classNames(styles.thumbnail, { [styles.noImage]: weed.images.length === 0 })}>
                        {this.props.loadImage && weed.images.length > 0 && <img src={weed.images?.[0]?.file} />}
                    </div>
                )}
                <div className={styles.names}>
                    <Title className={styles.common} color='dark' bolder>
                        {_(weed.name)}
                    </Title>
                    {weed.scientificName && (
                        <Title className={styles.scientific} color='dark'>
                            {weed.scientificName}
                        </Title>
                    )}
                </div>
            </div>
        );
    }
}
